export default "__VITE_ASSET__BmWl7xOo__"